import React from 'react'
import { motion } from "framer-motion";
import { Link } from "react-scroll"; 

function Pricing() {
  return (
    <div>
         {/* ===== PRICING ===== */}
      <section id="pricing" className="pricing">
        <h2 className="section__title">Flexible Pricing</h2>
        <div className="container pricing__plans">
          {[
            { plan: "Basic", price: "₹0", desc: "For personal use" },
            { plan: "Pro", price: "₹29", desc: "For professionals" },
            { plan: "Enterprise", price: "₹99", desc: "For teams and firms" },
          ].map((p, i) => (
            <motion.div
              className="plan"
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
            >
              <h3>{p.plan}</h3>
              <h1>{p.price}</h1>
              <p>{p.desc}</p>
              <button className="btn btn--primary">Choose Plan</button>
            </motion.div>
          ))}
        </div>
      </section>

    </div>
  )
}

export default Pricing